export default __webpack_public_path__ + "static/media/trr-drink-specialty-robinsonlatte.3a033090.png";